import DotNetObject = DotNet.DotNetObject;
import {
  PermissionGroup,
  PermissionGroupGetResponseModel,
  PermissionGroupResponseModel
} from '@crimsontide/core/client/interfaces';

export const PermissionGroupService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPermissionGroups: PermissionGroupGetResponseModel[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPermissionGroups = async (useCache: boolean = true): Promise<PermissionGroupGetResponseModel[]> => {
    if (useCache && cachedPermissionGroups != null)
      return cachedPermissionGroups;

    if (dotNetObj) {
      cachedPermissionGroups = await dotNetObj.invokeMethodAsync<PermissionGroupGetResponseModel[]>('GetAsync');
      return cachedPermissionGroups;
    } else {
      throw 'Permission Group DotNet Object Reference has not yet been implemented';
    }
  };


  const createAsync = async (newPermissionGroup: PermissionGroup): Promise<PermissionGroupResponseModel> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<PermissionGroupResponseModel>('CreateAsync', newPermissionGroup);
    } else {
      throw 'Permission Group DotNet Object Reference has not yet been implemented';
    }
  };

  const updateAsync = async (updatedPermissionGroup: PermissionGroup): Promise<PermissionGroupResponseModel> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<PermissionGroupResponseModel>('UpdateAsync', updatedPermissionGroup);
    } else {
      throw 'Permission Group DotNet Object Reference has not yet been implemented';
    }
  };

  const deleteAsync = async (permissionGroupToDelete: PermissionGroup): Promise<PermissionGroupResponseModel> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<PermissionGroupResponseModel>('DeleteAsync', permissionGroupToDelete);
    } else {
      throw 'Permission Group DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPermissionGroups,
    createAsync,
    updateAsync,
    deleteAsync
  };
})();
